const { Col, Row, Button } = require('antd')

const PatientPhotoButtons = ({ patientPhoto, children }) => {

  return (
    <Row className='patient-photo-buttons'>
      <Col lg={24} xs={24}>
        {children}
        <Row gutter={[20, 20]} className="mt-30">
          <Col xl={8} lg={10} xs={24}>
            <Button
              type="primary"
              className="cmt-button secondary"
              onClick={patientPhoto.openModal}
              size="large"
            >
              <span className="icon-camera-bold mr-10" />
              Tomar foto
            </Button>
          </Col>
          <Col xl={8} lg={10} xs={24}>
            <Button
              type="primary"
              className={`cmt-button ${patientPhoto.imageSrc && !patientPhoto.imageSrc?.includes('missing') ? 'secondary outline' : 'disabled outline'}`}
              onClick={patientPhoto.resetImage}
              disabled={patientPhoto.imageSrc?.includes('missing') || !patientPhoto.imageSrc}
              size="large"
            >
              <span className="icon-system-delete mr-10" />
              Eliminar foto
            </Button>
          </Col>
        </Row>
      </Col>
    </Row>
  );
};

export default PatientPhotoButtons;
